/**
 * @file Identity Tag Selection reducer.
 */

import {
  SELECT_TAG,
  DESELECT_TAG,
  CHECKOUT_TAG_SELECTION_REQUEST,
  CHECKOUT_TAG_SELECTION_FAILURE,
  CHECKOUT_TAG_SELECTION_SUCCESS,
  UPDATED_TAG,
  RESET_TAGS,
} from '../actions/identity-tag-selection';

/**
 * The `identities` object will store
 * an object containing:
 * - The identity ID
 * - Information related to tags.
 */
const initialState = {
  identities: [],
  loading: false,
  error: null,
  success: false,
  // This will allow checkout
  // whenever a tag was updated.
  updatedTag: false,
};

const identityTagSelectionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELECT_TAG: {
      if (!state.identities.some(({ id }) => id === action.identity.id)) {
        // This is a new identity. Add it to the list.
        return {
          ...state,
          identities: [
            ...state.identities,
            {
              ...action.identity,
              tags: [action.tag],
            },
          ],
        };
      }

      // This is an old identity. Add the new tag to it.
      return {
        ...state,
        identities: state.identities.map(identity => {
          if (identity.id !== action.identity.id) {
            return identity;
          }

          // If a tag exists, we might want to update rather than add as new
          const tagExist = identity.tags.some(({ id }) => id === action.tag.id);
          let tags;

          if (tagExist) {
            // Update this tag:
            tags = identity.tags.map(tag =>
              tag.id === action.tag.id ? action.tag : tag,
            );
          } else {
            // add tag:
            tags = [...identity.tags, action.tag];
          }

          return {
            ...identity,
            tags,
          };
        }),
      };
    }

    case DESELECT_TAG:
      return {
        ...state,
        identities: state.identities.map(identity => {
          if (identity.id !== action.identity.id) {
            return identity;
          }

          return {
            ...identity,
            tags: identity.tags.filter(tag => tag.id !== action.tag.id),
          };
        }),
      };

    case CHECKOUT_TAG_SELECTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case CHECKOUT_TAG_SELECTION_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };

    case CHECKOUT_TAG_SELECTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPDATED_TAG:
      return {
        ...state,
        updatedTag: true,
      };
    case RESET_TAGS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export { initialState };
export default identityTagSelectionReducer;
